import {getData, postData} from './http';
import * as broker from './broker';

import Flights = Core.Flights;
import Flight = Core.Flights.Flight;
import Leg = Core.Flights.Leg;
import Segment = Core.Flights.Segment;

const webUrl = 'website/flights/';
const promiseCache:Map<string,Promise<Flights.Details>> = new Map();

export function getFlightDetails(tripId:string, request: Flights.DetailsRequest): Promise<Flights.Details|null> {
    return getData<Flights.Details>(`${webUrl}details?${$.param(request)}`, {logErrors: false})
        .then(function(data) {
            if (data.ResponseCode === 1) {
                broker.publish('flightNotAvailable', tripId);
                return null;
            }
            return data;
        })
        .catch(function() {
            broker.publish('flightNotAvailable', tripId);
            return null;
        });
}

export function getBrandSpecificFlightDetails(BrandSpecificFlightId: string): Promise<Flights.Details|null> {
    return getData<Flights.Details>(`${webUrl}detailsbrandspecific?${$.param({
        BrandSpecificFlightId
    })}`, {logErrors: false});
}

export function rehydrate(id:string): Promise<Flights.Details> {
    if (promiseCache.has(id)) {
        return <Promise<Flights.Details>>promiseCache.get(id);
    }

    const promise = getData<Flights.Details>(`${webUrl}detailsfromsession?${$.param({ DetailsSessionId: id })}`);
    promiseCache.set(id, promise);

    let intvl = setInterval(function() {
        if (TRPCONFIG.Domain.BrandedFareCancellations) {
            clearInterval(intvl);
            sessionStorage.setItem('BrandedFareDetailsSessionId', id);
        }
    }, 100);
    return promise;
}

export function isHFlightType(flight: Flight): boolean {
    let isHFlight = false;
    const legs = _.get<Leg[]>(flight, 'Legs', []);
    legs.forEach((leg: Leg) => {
        const segments = _.get<Segment[]>(leg, 'Segments', []);
        segments.forEach((segment: Segment) => {
            if (segment.SupplierFareClass === 'H') {
                isHFlight = true;
            }
        });
    });
    return isHFlight;
}

//this is just a hack requried by quotes at the moment
export function mapLegs(req: Flights.IPartialFlight): Promise<{}> {
    return postData(`${webUrl}maplegs`, req)
        .then(f => _.omit(_.assign(req, f), ['OutboundLeg', 'InboundLeg']));
}
export function flightmiles(origin: string, destination: string, cabinCode: string, journeyType: string): Promise<any> {
    return getData<any>(`${webUrl}flightmiles?${$.param({
        origin, destination, cabinCode,journeyType
    })}`, { logErrors: false })
        .then(function (data) {
            if (data.ResponseCode === 404) {
                return null;
            }
            return data;
        })
        .catch(function () {
            return null;
        });
}
